import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  Select,
  FormLabel,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Checkbox,
} from "@chakra-ui/react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";
import { FaTrash, FaEdit } from "react-icons/fa";

const RoomServices = ({
  isOpen,
  onClose,
  toggle3,
  setToggle3,
  customerId,
  registration,
}) => {
  // const customerId=localStorage.getItem('customerId')
  const [roomService, setRoomService] = useState([]);
  const [service, setService] = useState([]);
  const [isOpen1, setIsOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editItemId, setEditItemId] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const [formData, setFormData] = useState({
    roomServiceName: "",
    roomServicePrice: 0,
    addDate: new Date().toISOString().split("T")[0],
    registration: registration,
    gst: false,
    gstPercentage: 0,
  });
  const fetchService = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomServiceAdd/${customerId}/${registration}`,
      );
      setService(response.data.addRoomService);
    } catch (error) {
      //toast.error(error.response.msg)
    }
  };
  const deleteService = async () => {
    try {
      const response = await axios.delete(
        `https://api.hotel.launchlysoftware.in/api/deleteRoomServiceAdd/${customerId}/${deleteItemId}`,
      );
      toast.success(response.data.message);
      setIsOpen(false);
      setDeleteItemId(" ");
      fetchService();
    } catch (error) {
      //  toast.error(error.response.msg)
    }
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };
  const EditModal = (item) => {
    console.log(item, "item");
    setEditItemId(item._id);
    setEdit(true);
    setFormData({
      roomServiceName: item.roomServiceName,
      roomServicePrice: item.roomServicePrice,
      addDate: item.addDate,
      gst: item.gst,
      gstPercentage: item.gstPercentage,
    });
  };
  const DeleteModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };
  const addRoomService = async (e) => {
    e.preventDefault();
    try {
      if (edit === true) {
        const response = await axios.put(
          `https://api.hotel.launchlysoftware.in/api/updateRoomServiceAdd/${customerId}/${editItemId}`,
          formData,
        );
        toast.success(response.data.message);
        setEditItemId(null);
        setEdit(false);
        setFormData({
          roomServiceName: "",
          roomServicePrice: 0,
          addDate: new Date().toISOString().split("T")[0],
          registration: registration,
          gst: false,
        });
        fetchService();
      } else {
        const reponse = await axios.post(
          `https://api.hotel.launchlysoftware.in/api/roomServiceAdd`,
          { customerId: customerId, data: formData },
        );
        toast.success(reponse.data.message);
        fetchService();
      }
    } catch (error) {
      toast.error(error.response.msg);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const fetchRoomServices = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomService/${customerId}`,
      );
      setRoomService(response.data.roomService);
    } catch (error) {
      toast.error(error.response.msg);
    }
  };
  const handleClick = () => {
    setToggle3(!toggle3);
    // setBookingData([])
  };
  useEffect(() => {
    fetchRoomServices();
    fetchService();
  }, [customerId]);
  useEffect(() => {
    let roomServices = roomService.filter((service) => {
      return service.roomServiceName === formData.roomServiceName;
    });
    let servicePrice = roomServices[0]?.roomServicePrice;
    //console.log(roomServices,servicePrice)
    if (edit === true) {
      setFormData((prev) => ({
        ...prev,
        roomServicePrice: formData.roomServicePrice,
      }));
    }
    setFormData((prev) => ({
      ...prev,
      roomServicePrice: servicePrice,
    }));
  }, [formData.roomServiceName]);
  return (
    <Modal isOpen={isOpen} onClose={onClose} width="full" size="3xl">
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>Room Services</Text>
          <Button colorScheme="red" onClick={handleClick}>
            <IoMdClose />
          </Button>
        </ModalHeader>

        <ModalBody>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="left"
            justifyContent="center"
          >
            <AlertDialog
              isOpen={isOpen1}
              leastDestructiveRef={cancelRef}
              onClose={onClose1}
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    Confirm Deletion
                  </AlertDialogHeader>

                  <AlertDialogBody>
                    Are you sure you want to delete this item?
                  </AlertDialogBody>

                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose1}>
                      Cancel
                    </Button>
                    <Button colorScheme="red" onClick={deleteService} ml={3}>
                      Delete
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>

            <Box
              display="flex"
              justifyContent="space-evenly"
              alignItems="center"
              w="full"
              bg="white"
              p="2"
              borderRadius="md"
              mb="2"
            >
              <Box
                w="60%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormLabel>Service Name</FormLabel>
                <Select
                  width="50%"
                  placeholder="Select Room Service"
                  name="roomServiceName"
                  value={formData.roomServiceName}
                  onChange={handleInputChange}
                >
                  {roomService.map((item, index) => (
                    <option key={index} value={item.roomServiceName}>
                      {item.roomServiceName}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box
                w="30%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormLabel>Price</FormLabel>
                <Input
                  width="40%"
                  name="roomServicePrice"
                  value={formData.roomServicePrice}
                  onChange={handleInputChange}
                />
              </Box>
              <Box
                w="30%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Checkbox
                  width="40%"
                  name="gst"
                  isChecked={formData.gst}
                  onChange={handleCheckboxChange}
                >
                  Gst
                </Checkbox>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="space-evenly"
              alignItems="center"
              w="full"
              bg="white"
              p="2"
              borderRadius="md"
              mb="2"
            >
              <Box
                w="40%"
                display="flex"
                alignItems="center "
                justifyContent="center"
              >
                <FormLabel>Date</FormLabel>
                <Input
                  width="50%"
                  type="date"
                  name="addDate"
                  value={formData.addDate}
                  onChange={handleInputChange}
                />
              </Box>
              <Box
                w="40%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormLabel>Registration</FormLabel>
                <Input
                  width="50%"
                  name="registration"
                  value={formData.registration}
                  onChange={handleInputChange}
                  readOnly
                />
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent="space-evenly"
              alignItems="center"
              w="full"
              p="2"
              borderRadius="md"
              mb="2"
            >
              <Button
                variant="solid"
                colorScheme="blue"
                onClick={addRoomService}
              >
                {edit === true ? "Update" : "Add"}
              </Button>
            </Box>
            <Box
              display="column"
              alignItems="center"
              justifyContent="center"
              w="full"
              p="2"
              borderRadius="md"
              mb="2"
            >
              {service?.map((item, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-evenly"
                  alignItems="center"
                  w="full"
                  bg="white"
                  p="2"
                  borderRadius="md"
                  mb="2"
                >
                  <Box
                    w="30%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text>{item.roomServiceName}</Text>
                  </Box>
                  <Box
                    w="30%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text>{item.roomServicePrice}</Text>
                  </Box>
                  <Box
                    w="30%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text>{item.addDate}</Text>
                  </Box>
                  <Button colorScheme="green" onClick={() => EditModal(item)}>
                    <FaEdit />
                  </Button>

                  <Button
                    colorScheme="red"
                    onClick={() => DeleteModal(item._id)}
                  >
                    <FaTrash />
                  </Button>
                </Box>
              ))}
            </Box>
          </Box>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RoomServices;
